// import { Controller } from '@hotwired/stimulus';
// import FileUploadController from '../../../../javascript/controllers/portal/components/file_upload_controller';
import FileUploadController from '@controllers/portal/components/file_upload_controller';

export default class extends FileUploadController {
  static targets = ["list", "optionNameInput", "addBtn", 'submitButton', 'input', 'optionItem', 'positionField', 'optionsContainer'];
  currTarget = 0;
  connect() {
    // eslint-disable-next-line no-console
    this.index = parseInt(document.getElementById('option-set-index').value, 10)
  }
  
  inputChanged() {
    const isEmpty = this.inputTarget.value.trim() === '';
    this.submitButtonTarget.disabled = isEmpty
  }
  
  addOption(e) {
    e.preventDefault();
    const template = document.getElementById('option-template');
    const optionName = this.optionNameInputTarget.value.trim();
    const clone = template.content.cloneNode(true)
    
    // this is the option name/image row preview
    clone.querySelector('[data-field="name"]').textContent = optionName
    clone.querySelector('[data-field="icon"]').src = this.iconUrl
    
    const nameInput = document.createElement('input')
    nameInput.type = "hidden"
    nameInput.name = `option_set[options_attributes][${this.index}][name]`
    nameInput.value = optionName
    
    const fileClone = this.fileTarget.cloneNode(true)
    fileClone.name = `option_set[options_attributes][${this.index}][uploaded_icon]`
    
    const row = clone.querySelector('[data-option-row]');
    // newly created options do not have DB id yet so we assign a temporary id
    // to link the row with its hidden position input, this allows us to this.updateAllPositions
    // when we moveUp or moveDown existing rows and temporary rows
    const optionId = `new-${this.index}`;
    row.dataset.optionsListId = optionId;
    
    const positionInput = clone.querySelector(`[data-${this.identifier}-target="positionField"]`);
    positionInput.name = `option_set[options_attributes][${this.index}][position]`;
    // newly created options will take last position but can be moved up and down
    positionInput.value = this.optionItemTargets.length + 1;
    positionInput.dataset.optionId = optionId;

    row.appendChild(nameInput)
    row.appendChild(fileClone)
    row.appendChild(positionInput)
    
    this.optionsContainerTarget.appendChild(clone)
    
    this.optionNameInputTarget.value = ""
    this.iconUrl = "";
    this.addBtnTarget.disabled = true;
    this.index += 1
  }
  
  handleFileInputChange() {
    const isValid = super.canUploadFile()
    if (!isValid) return
    const file = this.fileTarget.files[0]
    this.iconUrl = URL.createObjectURL(file)
    
    this.updateAddBtnState();
  }
  
  remove(e) {
    e.preventDefault()
    const row = e.target.closest("[data-option-row]");
    if (row) row.remove()
    
  }
  
  markForDeletion(e) {
    e.preventDefault();
    const row = e.target.closest('[data-option-row]')
    const destroyInput = row.querySelector('[data-destroy-field]')
    destroyInput.value = '1';
    row.style.display = 'none';
  }
  
  // Implementation similar to how product option set handles reordering of options
  moveOptionUp(e) {
    const currentItem = e.currentTarget.closest('[data-option-row]'); 
    const previousItem = currentItem.previousElementSibling;
    
    if (previousItem) {
      currentItem.parentNode.insertBefore(currentItem, previousItem);
    } else {
      currentItem.parentNode.appendChild(currentItem);
    }
    this.updateAllPositions();
  }
  
  moveOptionDown(e) {
    const currentItem = e.currentTarget.closest('[data-option-row]');
    const nextItem = currentItem.nextElementSibling;
    
    if (nextItem) {
      currentItem.parentNode.insertBefore(nextItem, currentItem);
    } else {
      currentItem.parentNode.insertBefore(currentItem, currentItem.parentNode.firstChild);
    }
    this.updateAllPositions();
  }

  updateAllPositions() {
    this.optionItemTargets.forEach((item, index) => {
      const optionId = item.dataset.optionsListId;
      const positionField = this.positionFieldTargets.find(field => field.dataset.optionId === optionId);
      if (positionField) {
        positionField.value = index + 1;
      }
    });
  }
  
  updateAddBtnState() {
    const hasOptionName = this.optionNameInputTarget.value.trim().length > 0;
    
    this.addBtnTarget.disabled = !hasOptionName;
  }
}
